import { Injectable } from '@angular/core';
import { StatusBar, StatusBarInfo, Style } from '@capacitor/status-bar';
//import { APP, NAV_BAR_COLORS } from '../../const/app.const';
import { NavigationBar } from '@hugotomazi/capacitor-navigation-bar';
import { Platform } from '@ionic/angular';

import { INavColor, INavStyle, ThemeService } from '@azz-life-streamer/shared';
//import { INavColor, INavStyle } from '../../interfaces/navigation-bar-color.interface';
import { Subscription } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class UtilsAndroidSharedService {
  noDistractionMode: boolean = false;
  //curNavColor: INavColor = NAV_BAR_COLORS.white;
  curNavColor: INavColor = {
    dark: {darkButtons: true, color: 'black'},
    light: {darkButtons: true, color: 'black'},
  };

  private themeSubscription: Subscription;

  constructor(private platform: Platform, private themeService: ThemeService) {
    this.themeSubscription = this.themeService.curTheme$.subscribe((theme: string) => {
      switch(theme){
        case 'dark':
          this.changeStatusBar(Style.Dark);
          break;
        case 'light':
          this.changeStatusBar(Style.Light);
          break;
        case 'default':
          this.changeStatusBar(Style.Default);
          break;
      }
      this.setColorNavigationBar(this.curNavColor);
    });
  }

  ngOnDestroy(): void {
    this.themeSubscription?.unsubscribe();
  }

  public changeStatusBar(style: Style): void {
    this.setOverlayWebView(true);
    if (this.isAndroidNative()) {

      StatusBar.getInfo().then((info: StatusBarInfo) => {
        // console.log('[UTILS]: changeStatusBar is Android - info: ', info);
        if (!info.visible) {
          StatusBar.show().catch(console.error);
        }

        let newStyle: Style = style;

        // switch (style) {
        //   case APP.statusbarStyle.dark:
        //     newStyle = this.themeService.selectedTheme === APP.statusbarStyle.dark
        //         ? Style.Dark
        //         : Style.Light;
        //     break;
        //   case APP.statusbarStyle.light:
        //     newStyle = this.themeService.selectedTheme === APP.statusbarStyle.light
        //         ? Style.Light
        //         : Style.Dark;
        //     break;
        //   default:
        //     newStyle = Style.Default;
        //     break;
        // }

        if (newStyle !== info.style) {
          StatusBar.setStyle({ style: newStyle }).catch(console.error);
        }
      });
    }
  }

  private setOverlayWebView(overlay: boolean): void {
    // console.log('[UTILS] setOverlayWebView:', overlay );
    if (this.isAndroidNative()) {
      // console.log('[UTILS] setOverlayWebView is ANDROID');
      StatusBar.setOverlaysWebView({ overlay })
        .catch(console.error);
    }
  }

  public setColorNavigationBar(color: INavColor): void {
    if (this.isAndroidNative()) {
      this.curNavColor = color;
      this.setTransparencyNavigationBar(false);
      const NAV_BAR_STYLE: INavStyle = this.themeService.selectedTheme === 'dark' ? color.dark : color.light;
      NavigationBar.setColor(NAV_BAR_STYLE).
        catch(console.error);
    }
  }

  public hideNavigationBar(): void {
    if (this.isAndroidNative()) {
      this.setTransparencyNavigationBar(true);
      NavigationBar.hide()
        .catch(console.error);

      /*NavigationBar.addListener(NavigationBarPluginEvents.SHOW, () => {
         console.error('APPEARS NAVIGATION BAR****');
         timer(5000)
           .pipe(
             tap(() => {
               console.warn('TRIES TO HIDE IT****');
               NavigationBar.hide()
                            .then(_ =>  console.warn('AFTER HIDE NAVIGATION BAR****'))
                            .catch(console.error);
             })
            );
         });*/
    }
  }

  public showNavigationBar(): void {
    if (this.isAndroidNative()) {
      this.setTransparencyNavigationBar(false);
      NavigationBar.show()
        .catch(console.error);
    }
  }

  public enableNoDistractionScreen(): void {
    this.noDistractionMode = true;
    if (this.isAndroidNative()) {
      this.changeStatusBar(Style.Light);
      this.hideStatusBar()
        .catch(console.error);
      this.hideNavigationBar();
    }
  }

  public disableNoDistractionScreen(): void {
    this.noDistractionMode = false;
    if (this.isAndroidNative()) {
      this.showStatusBar();
      this.showNavigationBar();
    }
  }

  public async hideStatusBar(): Promise<void> {
    // console.log('[UTILS]: hideStatusBar');
    if (this.isAndroidNative()) {
      // console.log('[UTILS]: hideStatusBar is Android');
      StatusBar.hide()
        .catch(console.error);
    }
  }

  public showStatusBar(): void {
    // console.log('[UTILS]: showStatusBar');
    if (this.isAndroidNative())
      // console.log('[UTILS]: showStatusBar is Android');
      StatusBar.show()
        .catch(console.error);
  }


  public setTransparencyNavigationBar(isTransparent: boolean): void {
    if (this.isAndroidNative()) {
      NavigationBar.setTransparency({ isTransparent })
        .catch(console.error);
    }
  }


  private isAndroidNative(): boolean {
    return  (this.platform.is('android') &&
      !this.platform.is('desktop') &&
      !this.platform.is('pwa') &&
      !this.platform.is('mobileweb'))
  }
}
